import { useFormatter } from "./useFormatter";

// Estados base de una factura/venta rápida (estado numérico guardado en BD)
const ESTADOS_BASE = {
  0: { text: "Cerrada", className: "bg-soccess color-white" },
  1: { text: "Abierta", className: "bg-naranja color-white" },
  2: { text: "Pendiente", className: "bg-yellow color-white" },
};

// Regla única para saber si una factura/venta "Abierta" (estado 1) ya está
// vencida: misma condición que usa el backend para las notificaciones de
// inicio de sesión (estado 1 + fecha límite de pago ya pasada).
export const useEstadoFactura = () => {
  const { formatDateInput, formtTodayBogota } = useFormatter();

  const calcularEstadoFactura = ({ estado, fechaVencimiento, tipo = "venta" }) => {
    if (tipo === "cotizacion") {
      return estado === 2
        ? { text: "Cotización", className: "bg-azul color-white" }
        : { text: "", className: "" };
    }

    const hoy = formtTodayBogota();
    const fechaVencStr = fechaVencimiento
      ? formatDateInput(fechaVencimiento, "UTC")
      : null;
    const estaVencida = estado === 1 && !!fechaVencStr && fechaVencStr <= hoy;

    if (estaVencida) {
      return { text: "Vencida", className: "bg-red color-white" };
    }

    return ESTADOS_BASE[estado] || { text: "", className: "" };
  };

  return { calcularEstadoFactura };
};
